/**
 * ゲストとして見ていた uid を、会員になったあとに繋ぐための控え。
 *
 * ゲストが Google でログインしたとき、その Google アカウントが既に会員なら既存アカウントが
 * 優先され、匿名 uid は捨てられる（lib/auth.ts の決定 10）。Firebase Auth は 2 つの uid を
 * 統合できないので、捨てる直前に匿名 uid を覚えておき、ログイン後に控えとして送る。
 *
 * 2026-10-02 の本番テスト配信では、同一のメールと電話を持つ注文が別の uid で 2 件あり、
 * 1 人が 2 人として数えられていた。
 *
 * 記録はサーバーで検証できない申告であり、ログインや購入を止めてはいけない。だからすべて
 * best effort で、失敗しても黙って諦める。
 */
import { httpsCallable } from 'firebase/functions';

import { commerceFunctionName, commerceTestPreview } from './commerce-test-preview';
import { getFunctionsInstance } from './firebase';

const KEY = 'nomiss-guest-uid';

/** 匿名セッションが失われる前に uid を覚える */
export function rememberGuestUid(uid: string | null | undefined): void {
  if (!uid) return;
  try {
    sessionStorage.setItem(KEY, uid);
  } catch {
    // 保存できない環境では繋げないだけ。
  }
}

function takeGuestUid(): string | null {
  try {
    const uid = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return uid;
  } catch {
    return null;
  }
}

/** ログイン後に 1 度だけ呼ぶ。覚えた uid が無い、または同じなら何もしない */
export async function reportGuestIdentityLink(memberUid: string): Promise<void> {
  const anonymousUid = takeGuestUid();
  if (!anonymousUid || anonymousUid === memberUid) return;
  // 隔離された検証経路にはこの関数を公開していない。名前の解決より前に抜ける。
  if (commerceTestPreview) return;
  try {
    await httpsCallable(
      getFunctionsInstance(),
      commerceFunctionName('recordViewerIdentityLink')
    )({ anonymousUid });
  } catch {
    // 分析の控えがログインを止めてはいけない。
  }
}
